import { render } from "./quoteThree.vue?vue&type=template&id=585bb2da"
import script from "./quoteThree.vue?vue&type=script&lang=js"
export * from "./quoteThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__